module.exports = __webpack_public_path__ + "img/nick-pfp.19d902ee.webp";